"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var SignaturePopup_1 = require("./SignaturePopup");
var test_json_data_1 = require("./test_json_data");
var sweetalert2_1 = __importDefault(require("sweetalert2"));
var moment_1 = __importDefault(require("moment"));
var constants_1 = require("./../server/common/constants");
var services_1 = require("./../server/services");
var helper_1 = require("../pdf/lib/functions/helper");
new SignaturePopup_1.SignaturePopup();
var submit_button = document.getElementById("submit_form_button");
if (submit_button) {
    submit_button.disabled = false;
    submit_button.addEventListener("click", submit);
}
if (process.env.DEBUG === "true") {
    window.pdf.json_data = test_json_data_1.test_json_data;
}
var secondary_json_data = {
    slug: process.env.SLUG,
    email_template_id: process.env.SLUG,
    pack_id: "avedamaine_req",
    form_type: "edularCore",
    version: "v3",
    skip: false,
    start_date: "2020-06-30",
    uploads: []
};
function submit() {
    return __awaiter(this, void 0, void 0, function () {
        var pdf, model, token, profileId, check, captcha_value, _a, status_1, body, message, searchEmailInput, emailValid, studentProfileId, taskDetail, nextCode, formData, newTask, roleId, AvedaMainCampus, additionalFilters_1, staffProfileId_1, assignPayload, subTasks, subTask, taskUserId, url, _b, status_2, body, error_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    pdf = window.pdf, model = window.model;
                    token = model.token, profileId = model.profileId;
                    return [4, pdf.validate()];
                case 1:
                    check = _c.sent();
                    if (!!check) return [3, 2];
                    alert("Please, complete the missing fields");
                    return [2];
                case 2:
                    console.log("@@@ check else");
                    captcha_value = window.pdf.json_data.captcha_value;
                    submit_button.disabled = true;
                    return [4, sendRequestCaptcha(__assign(__assign({}, secondary_json_data), { captcha_value: captcha_value }), "/v3/check/recaptcha/not-a-robot")];
                case 3:
                    _a = _c.sent(), status_1 = _a.status, body = _a.body;
                    if (!body.success) {
                        message = body.errors[0].message;
                        alert("".concat(message ? message : "Please check captcha errors."));
                        submit_button.disabled = false;
                        delete window.pdf.json_data.captcha_value;
                        window["grecaptcha"].reset();
                        return [2];
                    }
                    _c.label = 4;
                case 4:
                    searchEmailInput = model.json_data.email;
                    return [4, checkEmailSuccess(searchEmailInput)];
                case 5:
                    emailValid = (_c.sent()).body.data.emailValid;
                    if (!emailValid) {
                        return [2];
                    }
                    return [4, checkSearchStudentSuccess(searchEmailInput)];
                case 6:
                    studentProfileId = _c.sent();
                    if (!!studentProfileId) return [3, 8];
                    console.log("@@@ Student profile not found.");
                    return [4, sweetalert2_1.default.fire({
                            icon: "error",
                            title: "No profile info was found for the email=".concat(searchEmailInput, "."),
                            text: "Please contact +1 207-621-9941, to create the profile."
                        })];
                case 7:
                    _c.sent();
                    submit_button.disabled = false;
                    delete window.pdf.json_data.captcha_value;
                    window["grecaptcha"].reset();
                    return [2];
                case 8:
                    console.log("@@@ Student Profile ID:", studentProfileId);
                    pdf.setLoading(true);
                    _c.label = 9;
                case 9:
                    _c.trys.push([9, 17, 18, 19]);
                    return [4, getTaskDetail(model)];
                case 10:
                    taskDetail = (_c.sent()).body.data;
                    console.log("taskDetail*---->>", taskDetail);
                    return [4, getNextCode(model, taskDetail)];
                case 11:
                    nextCode = (_c.sent()).body.data;
                    formData = new FormData();
                    formData.append("name", taskDetail.name);
                    formData.append("description", taskDetail.description);
                    formData.append("dueDate", (0, moment_1.default)().add(7, "days").format("YYYY-MM-DD"));
                    formData.append("signers", JSON.stringify(taskDetail.form.signers.map(function (signer) { return (__assign(__assign({ type: signer.type, label: signer.label, order: signer.order, participantType: signer.participantType }, (signer.type === "staff" && { jsonData: { selectedOption: "fromDirectory" } })), { id: signer.id })); })));
                    formData.append("autoApprove", "0");
                    formData.append("departmentId", taskDetail.departmentId);
                    formData.append("taskCode", nextCode);
                    formData.append("reminders", JSON.stringify([]));
                    formData.append("cc", JSON.stringify([]));
                    formData.append("type", "form");
                    formData.append("subtype", "assigned");
                    formData.append("parentId", taskDetail.typeId);
                    formData.append("typeId", taskDetail.typeId);
                    formData.append("jsonData", JSON.stringify(taskDetail.jsonData));
                    return [4, createTask(model, formData)];
                case 12:
                    newTask = (_c.sent()).body.data;
                    console.log("newTask*---->>", newTask);
                    roleId = helper_1.DEFAULT_AVEDA_INFO.admissionsAdvisor.roleId, AvedaMainCampus = helper_1.DEFAULT_AVEDA_INFO.campuses[0].id;
                    additionalFilters_1 = {
                        roleId: roleId,
                        campusId: AvedaMainCampus
                    };
                    console.log("@@@@@@ additionalFilters:", additionalFilters_1);
                    return [4, checkSearchUserSuccess([additionalFilters_1.campusId], [additionalFilters_1.roleId])];
                case 13:
                    staffProfileId_1 = _c.sent();
                    if (!staffProfileId_1) {
                        console.log("@@@ Staff profile not found.");
                        return [2];
                    }
                    console.log("@@@ Staff Profile ID:", staffProfileId_1);
                    assignPayload = {
                        taskId: newTask.id,
                        signers: newTask.signers.map(function (signer) { return ({
                            signerId: signer.id,
                            type: signer.type,
                            users: [
                                {
                                    profileId: signer.type === "staff" ? +staffProfileId_1 : +studentProfileId
                                }
                            ],
                            sendToUsersByFilter: {
                                roleIds: [additionalFilters_1.roleId],
                                campus: [additionalFilters_1.campusId]
                            }
                        }); })
                    };
                    return [4, assignTaks(model, assignPayload)];
                case 14:
                    _c.sent();
                    return [4, getSubtask(model, newTask.id)];
                case 15:
                    subTasks = (_c.sent()).body.data;
                    subTask = subTasks[0];
                    taskUserId = subTask.users[0].id;
                    url = "/v3/tasks/answer";
                    return [4, sendRequest(model.json_data, url, token, taskUserId, profileId)];
                case 16:
                    _b = _c.sent(), status_2 = _b.status, body = _b.body;
                    pdf.setLoading(false);
                    submit_button.disabled = false;
                    if (status_2 !== 200) {
                        return [2];
                    }
                    showSuccessPage(body._id);
                    return [3, 19];
                case 17:
                    error_1 = _c.sent();
                    submit_button.disabled = false;
                    delete window.pdf.json_data.captcha_value;
                    window["grecaptcha"].reset();
                    console.log("error-->>>", error_1);
                    return [3, 19];
                case 18:
                    pdf.setLoading(false);
                    submit_button.disabled = false;
                    delete window.pdf.json_data.captcha_value;
                    window["grecaptcha"].reset();
                    return [7];
                case 19: return [2];
            }
        });
    });
}
function checkEmailSuccess(search) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, window.model.searchEmail(search)];
                case 1:
                    response = _a.sent();
                    if (!(response && response.success && response.data && typeof response.data === "string")) return [3, 2];
                    return [2, { status: 200, body: { data: { emailValid: true } } }];
                case 2: return [4, sweetalert2_1.default.fire({
                        icon: "error",
                        title: "Could not locate student with this email.",
                        text: "Use the same email that is on your school information record. Please contact +1 207-621-9941"
                    })];
                case 3:
                    _a.sent();
                    submit_button.disabled = false;
                    delete window.pdf.json_data.captcha_value;
                    window["grecaptcha"].reset();
                    return [2, { status: 404, body: { data: { emailValid: false } } }];
            }
        });
    });
}
function checkSearchStudentSuccess(search) {
    return __awaiter(this, void 0, void 0, function () {
        var students, foundStudent, profiles, id;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, window.model.searchStudent(search)];
                case 1:
                    _a.sent();
                    students = window.model.userList;
                    foundStudent = students.find(function (_a) {
                        var _b;
                        var emails = _a.emails;
                        return emails.length && ((_b = emails.find(function (email) { return email.isPrimary; })) === null || _b === void 0 ? void 0 : _b.email) === search;
                    });
                    console.log("@@@ foundStudent", foundStudent);
                    if (foundStudent) {
                        profiles = foundStudent.profiles;
                        if (profiles.length > 0) {
                            id = profiles[0].id;
                            console.log("@@@ foundStudent ID", id);
                            return [2, id];
                        }
                    }
                    return [2, null];
            }
        });
    });
}
function checkSearchUserSuccess(campus, roleIds) {
    return __awaiter(this, void 0, void 0, function () {
        var staffs, foundStaff, profiles, id;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, window.model.searchUserByRoleIdCampus(campus, roleIds)];
                case 1:
                    _a.sent();
                    staffs = window.model.staffList;
                    foundStaff = staffs.find(function (_a) {
                        var profiles = _a.profiles;
                        return profiles.some(function (profile) {
                            return profile.campuses.some(function (_a) {
                                var campusId = _a.id;
                                return campus.includes(campusId);
                            }) &&
                                profile.roles.some(function (_a) {
                                    var roleId = _a.roleId;
                                    return roleIds.includes(roleId);
                                });
                        });
                    });
                    console.log("@@@ foundStaff", foundStaff);
                    if (foundStaff) {
                        profiles = foundStaff.profiles;
                        if (profiles.length > 0) {
                            id = profiles[0].id;
                            console.log("@@@ foundStaff ID", id);
                            return [2, id];
                        }
                    }
                    return [2, null];
            }
        });
    });
}
function submitObservations(reason) {
    if (reason === void 0) { reason = ""; }
    return __awaiter(this, void 0, void 0, function () {
        var taskUserId, token, pdf, profileId, check, fieldsToDelete, mainJsonData, _i, fieldsToDelete_1, field, url, _a, status_3, body, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    taskUserId = window.taskUserId, token = window.token, pdf = window.pdf, profileId = window.profileId;
                    return [4, pdf.validate()];
                case 1:
                    check = _b.sent();
                    if (!check) {
                        alert("Please, complete the missing fields");
                        return [2];
                    }
                    fieldsToDelete = findFieldsToDelete(window);
                    mainJsonData = __assign({}, window["post_json_data"]);
                    for (_i = 0, fieldsToDelete_1 = fieldsToDelete; _i < fieldsToDelete_1.length; _i++) {
                        field = fieldsToDelete_1[_i];
                        if (field in mainJsonData) {
                            delete mainJsonData[field];
                        }
                    }
                    pdf.setLoading(true);
                    url = "/v3/task-users/remark";
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, , 5]);
                    return [4, sendRequestObservations(pdf.json_data, url, token, taskUserId, profileId, reason, mainJsonData)];
                case 3:
                    _a = _b.sent(), status_3 = _a.status, body = _a.body;
                    pdf.setLoading(false);
                    if (status_3 !== 200) {
                        return [2];
                    }
                    showSuccessPage(body._id);
                    return [3, 5];
                case 4:
                    error_2 = _b.sent();
                    console.log(error_2);
                    return [3, 5];
                case 5: return [2];
            }
        });
    });
}
window.addEventListener("message", function (e) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (e.data.type === "action" && e.data.data === "submit") {
            submit();
        }
        return [2];
    });
}); });
window.addEventListener("message", function (e) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (e.data.type === "submitObservations") {
            submitObservations(e.data.data || "");
        }
        return [2];
    });
}); });
function reject(reason) {
    return __awaiter(this, void 0, void 0, function () {
        var taskUserId, token, pdf, status;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    taskUserId = window.taskUserId, token = window.token, pdf = window.pdf;
                    pdf.setLoading(true);
                    return [4, sendRequest({ taskUserId: taskUserId, reason: reason }, "/reject", token)];
                case 1:
                    status = (_a.sent()).status;
                    pdf.setLoading(false);
                    if (status !== 200) {
                        return [2];
                    }
                    showRejectedPage();
                    return [2];
            }
        });
    });
}
window.reject = reject;
function sendRequest(json_data, url, token, taskUserId, profileId) {
    return __awaiter(this, void 0, void 0, function () {
        var raw, myHeaders, rawResponse, body, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    raw = JSON.stringify({
                        taskUserId: taskUserId,
                        answers: json_data
                    });
                    myHeaders = new Headers();
                    myHeaders.append("Authorization", "Bearer ".concat(token));
                    myHeaders.append("Content-Type", "application/json");
                    myHeaders.append("x-profile-id", profileId);
                    return [4, fetch("".concat(process.env.TASKS_API).concat(url), {
                            method: "POST",
                            headers: myHeaders,
                            body: raw
                        })];
                case 1:
                    rawResponse = _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4, rawResponse.json()];
                case 3:
                    body = _a.sent();
                    return [3, 5];
                case 4:
                    e_1 = _a.sent();
                    body = {};
                    return [3, 5];
                case 5: return [2, { status: rawResponse.status, body: body }];
            }
        });
    });
}
function sendRequestCaptcha(json_data, url) {
    return __awaiter(this, void 0, void 0, function () {
        var rawResponse, body;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetch("".concat(process.env.API_DOMAIN).concat(url), {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(json_data)
                    })];
                case 1:
                    rawResponse = _a.sent();
                    return [4, rawResponse.json()];
                case 2:
                    body = _a.sent();
                    console.log(rawResponse.status);
                    console.log(body);
                    return [2, { status: rawResponse.status, body: body }];
            }
        });
    });
}
function getTaskDetail(model) {
    return __awaiter(this, void 0, void 0, function () {
        var raw, myHeaders, rawResponse, body, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    raw = JSON.stringify({
                        taskId: Number(process.env.TASK_ID),
                        linkedEntities: true
                    });
                    myHeaders = new Headers();
                    myHeaders.append("Authorization", "Bearer ".concat(model.token));
                    myHeaders.append("Content-Type", "application/json");
                    myHeaders.append("x-profile-id", model.profileId);
                    return [4, fetch("".concat(process.env.TASKS_API, "/v3/tasks/details"), {
                            method: "POST",
                            headers: myHeaders,
                            body: raw
                        })];
                case 1:
                    rawResponse = _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4, rawResponse.json()];
                case 3:
                    body = _a.sent();
                    return [3, 5];
                case 4:
                    e_2 = _a.sent();
                    body = {};
                    return [3, 5];
                case 5: return [2, { status: rawResponse.status, body: body }];
            }
        });
    });
}
function getNextCode(model, taskDetail) {
    return __awaiter(this, void 0, void 0, function () {
        var raw, myHeaders, rawResponse, body, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    raw = JSON.stringify({
                        parentTaskId: Number(process.env.TASK_ID),
                        isLibrary: false,
                        departmentId: taskDetail.departmentId
                    });
                    myHeaders = new Headers();
                    myHeaders.append("Authorization", "Bearer ".concat(model.token));
                    myHeaders.append("Content-Type", "application/json");
                    myHeaders.append("x-profile-id", model.profileId);
                    return [4, fetch("".concat(process.env.TASKS_API, "/v3/tasks/next-code"), {
                            method: "POST",
                            headers: myHeaders,
                            body: raw
                        })];
                case 1:
                    rawResponse = _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4, rawResponse.json()];
                case 3:
                    body = _a.sent();
                    return [3, 5];
                case 4:
                    e_3 = _a.sent();
                    body = {};
                    return [3, 5];
                case 5:
                    console.log("@@@ getNextCode", rawResponse.status, body);
                    return [2, { status: rawResponse.status, body: body }];
            }
        });
    });
}
function getSubtask(model, taskId) {
    return __awaiter(this, void 0, void 0, function () {
        var raw, myHeaders, rawResponse, body, e_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    raw = JSON.stringify({
                        filter: { taskId: taskId },
                        range: { page: 1, pageSize: 1000 }
                    });
                    myHeaders = new Headers();
                    myHeaders.append("Authorization", "Bearer ".concat(model.token));
                    myHeaders.append("Content-Type", "application/json");
                    myHeaders.append("x-profile-id", model.profileId);
                    return [4, fetch("".concat(process.env.TASKS_API, "/v3/subtasks/list"), {
                            method: "POST",
                            headers: myHeaders,
                            body: raw
                        })];
                case 1:
                    rawResponse = _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4, rawResponse.json()];
                case 3:
                    body = _a.sent();
                    return [3, 5];
                case 4:
                    e_4 = _a.sent();
                    body = {};
                    return [3, 5];
                case 5: return [2, { status: rawResponse.status, body: body }];
            }
        });
    });
}
function assignTaks(model, payload) {
    return __awaiter(this, void 0, void 0, function () {
        var raw, myHeaders, rawResponse, body, e_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    raw = JSON.stringify(payload);
                    console.log("@@@ Payload (raw):", raw);
                    myHeaders = new Headers();
                    myHeaders.append("Authorization", "Bearer ".concat(model.token));
                    myHeaders.append("Content-Type", "application/json");
                    myHeaders.append("x-profile-id", model.profileId);
                    console.log("@@@ Headers:", myHeaders);
                    return [4, fetch("".concat(process.env.TASKS_API, "/v3/tasks/assign"), {
                            method: "POST",
                            headers: myHeaders,
                            body: raw
                        })];
                case 1:
                    rawResponse = _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4, rawResponse.json()];
                case 3:
                    body = _a.sent();
                    console.log("@@@ Response body (JSON):", body);
                    return [3, 5];
                case 4:
                    e_5 = _a.sent();
                    console.log("@@@ Error parsing JSON response:", e_5);
                    body = {};
                    return [3, 5];
                case 5: return [2, { status: rawResponse.status, body: body }];
            }
        });
    });
}
function createTask(model, payload) {
    return __awaiter(this, void 0, void 0, function () {
        var myHeaders, rawResponse, body, e_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    myHeaders = new Headers();
                    myHeaders.append("Authorization", "Bearer ".concat(model.token));
                    myHeaders.append("x-profile-id", model.profileId);
                    return [4, fetch("".concat(process.env.TASKS_API, "/v3/tasks/create"), {
                            method: "POST",
                            headers: myHeaders,
                            body: payload
                        })];
                case 1:
                    rawResponse = _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4, rawResponse.json()];
                case 3:
                    body = _a.sent();
                    return [3, 5];
                case 4:
                    e_6 = _a.sent();
                    body = {};
                    return [3, 5];
                case 5: return [2, { status: rawResponse.status, body: body }];
            }
        });
    });
}
function createUser(model, data) {
    return __awaiter(this, void 0, void 0, function () {
        var userService, newUserData, fieldName, email, phone, restNewUserData, response, e_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userService = new services_1.UserService(model.token, model.profileId);
                    newUserData = {};
                    for (fieldName in data) {
                        if (fieldName.startsWith("".concat(constants_1.USER_INDEX.userData, "-"))) {
                            newUserData[fieldName.replace("".concat(constants_1.USER_INDEX.userData, "-"), "")] = data[fieldName];
                        }
                    }
                    email = newUserData.email, phone = newUserData.phone, restNewUserData = __rest(newUserData, ["email", "phone"]);
                    if (email) {
                        restNewUserData.emails = [{ email: email, isPrimary: true }];
                    }
                    if (phone) {
                        restNewUserData.phones = [{ phone: "".concat(phone), isPrimary: true }];
                    }
                    restNewUserData.password = constants_1.DEFAULT_PASSWORD;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, userService.createUser([restNewUserData])];
                case 2:
                    response = _a.sent();
                    return [2, response];
                case 3:
                    e_7 = _a.sent();
                    console.log("error creating the user--->>", e_7);
                    return [3, 4];
                case 4: return [2];
            }
        });
    });
}
function createProfile(model, userData) {
    return __awaiter(this, void 0, void 0, function () {
        var userService, newProfile, response, e_8;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    userService = new services_1.UserService(model.token, model.profileId);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    _a = {
                        isDefault: true,
                        userId: userData.id,
                        type: "student",
                        state: constants_1.UserProfileState.Prospect
                    };
                    return [4, userService.getNextCustomProfileId()];
                case 2:
                    newProfile = (_a.customProfileId = _b.sent(),
                        _a);
                    return [4, userService.createProfile([newProfile])];
                case 3:
                    response = _b.sent();
                    return [2, response];
                case 4:
                    e_8 = _b.sent();
                    console.log("error creating the user--->>", e_8);
                    return [3, 5];
                case 5: return [2];
            }
        });
    });
}
function sendRequestObservations(json_data, url, token, taskUserId, profileId, reason, mainJsonData) {
    return __awaiter(this, void 0, void 0, function () {
        var observationsKeys, remarks, raw, myHeaders, rawResponse, body, e_9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    observationsKeys = Object.keys(json_data).filter(function (item) { return item.includes("_observation"); });
                    remarks = {};
                    observationsKeys.forEach(function (obs) {
                        remarks[obs] = json_data[obs];
                    });
                    raw = JSON.stringify({
                        taskUserId: taskUserId,
                        remarks: remarks,
                        reason: reason,
                        answersWebForm: mainJsonData
                    });
                    myHeaders = new Headers();
                    myHeaders.append("Authorization", "Bearer ".concat(token));
                    myHeaders.append("Content-Type", "application/json");
                    myHeaders.append("x-profile-id", profileId);
                    return [4, fetch("".concat(process.env.TASKS_API).concat(url), {
                            method: "POST",
                            headers: myHeaders,
                            body: raw
                        })];
                case 1:
                    rawResponse = _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4, rawResponse.json()];
                case 3:
                    body = _a.sent();
                    return [3, 5];
                case 4:
                    e_9 = _a.sent();
                    body = {};
                    return [3, 5];
                case 5: return [2, { status: rawResponse.status, body: body }];
            }
        });
    });
}
function showSuccessPage(id) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            sweetalert2_1.default.fire({
                icon: "success",
                title: "Request sent",
                text: "The form has been sent to an advisor",
                width: "500px"
            }).then(function () {
                window.location.assign(process.env.BASE_DOMAIN);
                location.reload();
            });
            return [2];
        });
    });
}
function showRejectedPage() {
    return __awaiter(this, void 0, void 0, function () {
        var rejectedUrl;
        return __generator(this, function (_a) {
            rejectedUrl = window.rejectedUrl;
            window.top.location.href = rejectedUrl;
            return [2];
        });
    });
}
function findFieldsToDelete(window) {
    var _a, _b, _c, _d, _e, _f, _g;
    var taskUserId = window.taskUserId, pdf = window.pdf;
    var model = window["model"];
    var fields = document.querySelectorAll('[class^="form-user-"],[class*=" form-user-"],select, input, radio');
    var fieldsFound = [];
    var signerId = ((_c = (_b = (_a = model === null || model === void 0 ? void 0 : model.task) === null || _a === void 0 ? void 0 : _a.subtask) === null || _b === void 0 ? void 0 : _b.users) === null || _c === void 0 ? void 0 : _c.find(function (_a) {
        var id = _a.id;
        return id === taskUserId;
    }).signerId) || null;
    var firstSigner = (_e = (_d = model === null || model === void 0 ? void 0 : model.task) === null || _d === void 0 ? void 0 : _d.form) === null || _e === void 0 ? void 0 : _e.signers.find(function (_a) {
        var id = _a.id;
        return id === signerId;
    });
    var cssToDelete = (_g = (_f = model === null || model === void 0 ? void 0 : model.task) === null || _f === void 0 ? void 0 : _f.form) === null || _g === void 0 ? void 0 : _g.signers.filter(function (_a) {
        var order = _a.order;
        return order >= firstSigner.order;
    }).map(function (_a) {
        var css = _a.css;
        return css;
    });
    var regexSignature = new RegExp("(?=.*signature)", "i");
    var regexSignatureDate = new RegExp("(?=.*signature)(?=.*date)", "i");
    var regexInitial = new RegExp("(?=.*initial)", "i");
    var regexInitialDate = new RegExp("(?=.*initial)(?=.*date)", "i");
    cssToDelete.forEach(function (userCss) {
        for (var index = 0; index < fields.length; index++) {
            var field = fields[index];
            var classField = field.className
                .split(" ")
                .map(function (cssField) { return cssField.trim(); })
                .filter(function (cssField) { return cssField.startsWith("form-user-"); })
                .join("")
                .split("-");
            if (classField.find(function (css) { return css === userCss; })) {
                fieldsFound.push(field.id);
            }
        }
        fieldsFound.push("form-signature-".concat(userCss));
        fieldsFound.push("form-initial-".concat(userCss));
    });
    var fieldsToDelete = fieldsFound.filter(function (field) {
        return regexSignature.test(field) ||
            regexSignatureDate.test(field) ||
            regexInitial.test(field) ||
            regexInitialDate.test(field);
    });
    return fieldsToDelete;
}
function waitUntilJobComplete(id) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            return [2, new Promise(function (resolve, reject) {
                    var interval_id = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
                        var status, body, r, e_10;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4, sendRequest({}, "/check/".concat(id))];
                                case 1:
                                    r = _a.sent();
                                    status = r.status;
                                    body = r.body;
                                    return [3, 3];
                                case 2:
                                    e_10 = _a.sent();
                                    clearInterval(interval_id);
                                    clearTimeout(timeout_id);
                                    reject(e_10);
                                    return [2];
                                case 3:
                                    console.log(body.jobs);
                                    if (status !== 200) {
                                        clearInterval(interval_id);
                                        clearTimeout(timeout_id);
                                        reject("Got status code not 200 from API");
                                    }
                                    if (body.jobs.status === "done") {
                                        clearInterval(interval_id);
                                        clearTimeout(timeout_id);
                                        resolve(true);
                                    }
                                    return [2];
                            }
                        });
                    }); }, 3000);
                    var timeout_id = setTimeout(function () {
                        clearInterval(interval_id);
                        reject(new Error("1 minute timeout reached"));
                    }, 60 * 1000);
                })];
        });
    });
}
//# sourceMappingURL=data:application/json;base64,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